import { AIRE_APPS, AIRE_ROLES } from "./types.js";
const ROLE_SET = new Set(AIRE_ROLES);
const AIRE_GROUP_ENVIRONMENTS = ["dev", "uat", "prod"];
const AIRE_GROUP_ENVIRONMENT_PATTERN = AIRE_GROUP_ENVIRONMENTS.join("|");
const AIRE_PERMISSION_GROUP_PATTERN = new RegExp(`^lio-(${AIRE_GROUP_ENVIRONMENT_PATTERN})-aire-(viewer|preparer|approver)-([a-z0-9-]+?)(-delegate)?$`, "u");
const IGNORED_CROSS_CUTTING_GROUP_PATTERN = /^lio-(dev|uat|prod)-aire-(mcp-actor|breakglass-eligible)$/u;
// This module is intentionally free of any Node-only / server-only dependency so it can be
// imported into the browser bundle via the `@lio-aire/auth-utils/browser` subpath export. The
// default `warn` is a no-op here; the server barrel (`index.ts`) wraps `parseGroups` to attach
// the Powertools logger that emits the documented `UnknownAireGroup` WARN line.
export function parseGroups(groups, opts = {}) {
    const warn = opts.warn ?? (() => undefined);
    const permissions = [];
    let isAdmin = false;
    let isAuditor = false;
    for (const group of groups) {
        if (/^lio-(dev|uat|prod)-aire-admin$/u.test(group)) {
            isAdmin = true;
            continue;
        }
        if (/^lio-(dev|uat|prod)-aire-auditor$/u.test(group)) {
            isAuditor = true;
            continue;
        }
        if (IGNORED_CROSS_CUTTING_GROUP_PATTERN.test(group)) {
            continue;
        }
        if (!group.startsWith("lio-")) {
            continue;
        }
        const match = AIRE_PERMISSION_GROUP_PATTERN.exec(group);
        if (match === null) {
            warn(group);
            continue;
        }
        const [, , role, entity] = match;
        if (!isKnownRole(role) || entity === undefined) {
            warn(group);
            continue;
        }
        for (const app of AIRE_APPS) {
            permissions.push({
                app,
                role,
                entity: entity.toUpperCase(),
            });
        }
    }
    return { permissions, isAdmin, isAuditor };
}
function isKnownRole(value) {
    return value !== undefined && ROLE_SET.has(value);
}
//# sourceMappingURL=group-parser.js.map